// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__W4CZy","explore":"ProjectCard_explore__XXQDE","projectDetails":"ProjectCard_projectDetails__8td5O"};